import React, { Fragment, useCallback } from 'react';
import Button from 'components/shared/Button';
import Typo from 'components/shared/Typo';
import ResetGainsConfirmDialog from './ResetGainsConfirmDialog';

function ResetGainsDialog({ open, locked, sector, onCancel, onConfirm }) {
  const handResetGains = useCallback(() => onConfirm({ sector }), [onConfirm, sector]);

  return (
    locked && (
      <ResetGainsConfirmDialog
        open={open}
        title={
          <Typo as="h3" variant="heading5">
            Are you sure you want to clear Sector {sector}'s gain control parameters?
          </Typo>
        }
        description={
          <Typo paragraph variant="body2">
            This command will erase Sector {sector}'s gain control parameters, forcing the sector to undergo a gain
            configuration process that can last up to 10 minutes the next time it is put in service.
          </Typo>
        }
        actions={
          <Fragment>
            <Button variant="text" color="primary" size="medium" onClick={onCancel}>
              Cancel
            </Button>
            <Button variant="contained" color="error" size="medium" onClick={handResetGains}>
              <Typo>Yes, clear gain control parameters</Typo>
            </Button>
          </Fragment>
        }
      />
    )
  );
}

export default ResetGainsDialog;
